import { AllowedService } from "../../taskpane/authentication/AuthorizationContext";

export function isFeatureVisible(allowedfeatures: AllowedService[], componentFeatureName: string): boolean {
  return (
    allowedfeatures.filter(
      (item: AllowedService) =>
        item.serviceId == "krs-add-in-app-v1" && (item.feature == componentFeatureName || item.feature == "management")
    ).length > 0
  );
}
